var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1774_1635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2708 11.0833H11.6454L11.4238 10.8696C12.1996 9.96708 12.6667 8.79542 12.6667 7.52083C12.6667 4.67875 10.3629 2.375 7.52083 2.375C4.67875 2.375 2.375 4.67875 2.375 7.52083C2.375 10.3629 4.67875 12.6667 7.52083 12.6667C8.79542 12.6667 9.96708 12.1996 10.8696 11.4238L11.0833 11.6454V12.2708L15.0417 16.2213L16.2213 15.0417L12.2708 11.0833ZM7.52083 11.0833C5.54958 11.0833 3.95833 9.49208 3.95833 7.52083C3.95833 5.54958 5.54958 3.95833 7.52083 3.95833C9.49208 3.95833 11.0833 5.54958 11.0833 7.52083C11.0833 9.49208 9.49208 11.0833 7.52083 11.0833Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1774_1635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.05ff3749d99ed45be08d726cc834d25c.svg";
export { ForwardRef as ReactComponent };